import { Dispatch } from 'redux'

import { ApplicationState } from 'redux/Stores/types'
import { useThunkActions } from '../useThunkActions'
import * as globalFilterActions from 'redux/actions/GlobalFilter/actions'
import { ECurrency } from 'types/Enums'

import * as actions from './actions'

/** PRIVATE LOCAL STORAGE */

const getCurrencyKey = (customerId: string) =>
  `currencyConverter.currency.${customerId}`

function getStoredCurrency(customerId: string): ECurrency | null {
  const stored = localStorage.getItem(getCurrencyKey(customerId))

  if (
    stored !== null &&
    (Object.values(ECurrency) as string[]).includes(stored)
  ) {
    return stored as ECurrency
  }

  return null
}

function saveCurrency(customerId: string, currency: ECurrency | null): void {
  if (currency) {
    localStorage.setItem(getCurrencyKey(customerId), currency)
  } else {
    localStorage.removeItem(getCurrencyKey(customerId))
  }
}

/** THUNKS */

// Exported for initializeApp (redux/actions/AppInit); components use
// useCurrencyConverterActions below.
export function initializeCurrencyConverter() {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    const customer = getState().AuthStore.customer

    if (!customer?.allow_access.allow_currency_converter) {
      return
    }

    const stored = getStoredCurrency(customer.customer_id)
    const currency = stored ?? ECurrency.SEK

    saveCurrency(customer.customer_id, currency)
    dispatch(actions.setCurrency(currency))
  }
}

function setCurrency(currency: ECurrency | null) {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    const { AuthStore, GlobalFilterStore } = getState()

    if (AuthStore.customer) {
      saveCurrency(AuthStore.customer.customer_id, currency)
    }

    dispatch(
      globalFilterActions.update({
        companyGroupId: GlobalFilterStore.companyGroupId,
        currency,
        customSelected: GlobalFilterStore.customSelected,
        variant: GlobalFilterStore.variant
      })
    )
  }
}

export const useCurrencyConverterActions = () => {
  return {
    initializeCurrencyConverter: useThunkActions(initializeCurrencyConverter),
    setCurrency: useThunkActions(setCurrency)
  }
}
